export default __webpack_public_path__ + "static/4- swipe action-fabd88ba213d432a359109e3a3ede6aa.gif";